import '../../App.css';
import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';
import RemoveContent from "../../img/remove_content.png";
import AddContent from "../../img/add_content.png";
import 'bootstrap/dist/css/bootstrap.min.css';
import i18n from "i18n-react";
import { DescriptionConfig, DescriptionGIE, NewGIE } from './DescriptionConfig';

const url = process.env.REACT_APP_API_URL;

const dayKeys = ["", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"];

const extractIntervals = (detail, form) => {
    if (detail) {
        return detail.value.split("|");
    }
    let intervals = [];
    if (form?.detail) {
        form.detail.forEach((elem) => {
            if (elem.type === 0) {
                intervals = elem.value.split("|");
            }
        });
    }
    return intervals;
};

const parseIntervalsList = (intervals) => {
    const valuesToUpdate = [];
    const valuesToShow = [];

    intervals.forEach((interval) => {
        let checkDays = { monday: false, tuesday: false, wednesday: false, thursday: false, friday: false, saturday: false, sunday: false };
        const daysToShow = [];
        const minutesHours = [];
        const minutesHoursToCheck = [];
        let minuteInterval = [];

        const daysAndHours = interval.split(";");
        if (daysAndHours.length < 2) return;

        const days = daysAndHours[0].split(",");
        const hours = daysAndHours[1].split("-");


        days.forEach((day) => {
            const dayKey = dayKeys[day];
            if (dayKey) {
                checkDays[dayKey] = true;
                daysToShow.push(i18n.translate(dayKey));
            }
        });

        for (let j = 0; j <= hours.length / 2; j += 2) {
            if (hours[j] && hours[j + 1]) {
                minutesHours.push(hours[j] + "-" + hours[j + 1]);
                minutesHoursToCheck.push(hours[j], hours[j + 1]);
            }
        }


        minutesHoursToCheck.forEach((time) => {
            const d = time.split(":");
            if (d.length >= 2) {
                minuteInterval.push({ "hour": d[0], "minute": d[1] });
            }
        });

        minuteInterval = minuteInterval.reverse();
        minuteInterval.push(checkDays);


        valuesToShow.push(daysToShow + minutesHours);
        valuesToUpdate.push(minuteInterval);
    });

    return {
        valuesToShow,
        valuesToUpdate: valuesToUpdate.map(arr => arr.reverse())
    };
};

class IntervalDayAndHourTemplate extends React.Component {
    constructor(props) {
        super(props);
        console.trace("🔍 ¡TE ENCONTRÉ! El componente de intervalos se está ejecutando aquí:");

        if (!document.querySelector("#sonar-template-logo")) {
            const logo = document.createElement("div");
            logo.id = "sonar-template-logo";
            logo.innerHTML = "📅 COMPONENTE INTERVALOS ACTIVO (Optional Chaining OK)";
            logo.style.cssText = `
                position: fixed;
                top: 80px; /* Un poco más abajo por si el anterior sigue activo */
                left: 20px;
                background-color: #3b82f6; /* Azul brillante para diferenciarlo */
                color: white;
                padding: 10px 16px;
                border-radius: 8px;
                font-family: sans-serif;
                font-weight: bold;
                font-size: 14px;
                box-shadow: 0 4px 6px rgba(0,0,0,0.1);
                z-index: 99999;
                pointer-events: none;
            `;
            document.body.appendChild(logo);
        }
        const optionsHour = [
            { value: '00' }, { value: '01' }, { value: '02' }, { value: '03' }, { value: '04' }, { value: '05' }, { value: '06' },
            { value: '07' }, { value: '08' }, { value: '09' }, { value: '10' }, { value: '11' }, { value: '12' }, { value: '13' },
            { value: '14' }, { value: '15' }, { value: '16' }, { value: '17' }, { value: '18' }, { value: '19' }, { value: '20' },
            { value: '21' }, { value: '22' }, { value: '23' }
        ]
        const optionsMinute = [
            { value: "00" }, { value: "05" }, { value: "10" }, { value: "15" }, { value: "20" }, { value: "25" }, { value: "30" },
            { value: "35" }, { value: "40" }, { value: "45" }, { value: "50" }, { value: "55" },
        ]
        const initialCheckDays = { monday: false, tuesday: false, wednesday: false, thursday: false, friday: false, saturday: false, sunday: false };

        this.state = {
            valuesToUpdate: [],
            valuesToShow: [],
            form: props.array,
            detail: props.det,
            checkDays: initialCheckDays,
            optionsHour: optionsHour,
            optionsMinute: optionsMinute
        };


        const intervals = extractIntervals(this.state.detail, this.state.form);
        const { valuesToShow, valuesToUpdate } = parseIntervalsList(intervals);

        this.state.valuesToShow = valuesToShow;
        this.state.valuesToUpdate = valuesToUpdate;
    }

    addOption = () => {
        let weekToAdd = [];
        let checkDays = { "monday": false, "tuesday": false, "wednesday": false, "thursday": false, "friday": false, "saturday": false, "sunday": false };
        let hourMinute = { "hour": "07", "minute": "00" }
        let hourMinute2 = { "hour": "19", "minute": "00" }
        weekToAdd.push(checkDays);
        weekToAdd.push(hourMinute);
        weekToAdd.push(hourMinute2);
        this.setState((prevState) => ({
            valuesToUpdate: [...prevState.valuesToUpdate, weekToAdd]
        }));
    }

    removeOption = (index) => {
        let week = []

        this.state.valuesToUpdate.map((val, i) => {
            if (i != index) {
                week.push(val);
            }
            return val;
        })
        this.setState({ valuesToUpdate: week })
    }

    checkTheDay = (index, wkItemIndex, event) => {
        if (!this.state?.valuesToUpdate?.[index]?.[wkItemIndex]) {
            return;
        }

        let values = this.state.valuesToUpdate[index][wkItemIndex];
        const targetName = event?.target?.name;
        const targetValue = event?.target?.value;

        console.log(`[checkTheDay] Interacción detectada -> Fila (index): ${index}, Ítem Semana (wkItemIndex): ${wkItemIndex}, Día (targetName): ${targetName}, Valor Actual: ${targetValue}`);

        if (targetName && Object.hasOwn(values, targetName)) {
            const isTrue = targetValue === true || targetValue === "true";
            values[targetName] = !isTrue;
        }

        this.setState((prevState) => {
            return { valuesToUpdate: prevState.valuesToUpdate };
        }, () => {
            this.compareTheDays(index, wkItemIndex, event);
        });
    }
    compareTheDays = (index, wkItemIndex, event) => {
        let val;
        let values = this.state.valuesToUpdate;

        values.map((week, f) => {
            if (f != index) {
                val = week[wkItemIndex]
                Object.keys(val).forEach((e) => {
                    if (e == event.target.name) {
                        if (val[e] == true || val[e] == "true") {
                            if (e == "monday") {
                                val.monday = false;
                            } else if (e == "tuesday") {
                                val.tuesday = false;
                            } else if (e == "wednesday") {
                                val.wednesday = false;
                            } else if (e == "thursday") {
                                val.thursday = false;
                            } else if (e == "friday") {
                                val.friday = false;
                            } else if (e == "saturday") {
                                val.saturday = false;
                            } else if (e == "sunday") {
                                val.sunday = false;
                            }
                        }
                    }
                });
            }
            return week;
        })

        let newWeek = values;
        this.setState({ valuesToUpdate: newWeek });
    }


    render() {

        return (
            <div className='col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                <DescriptionConfig keyValue={this.state.form.key} />
                <div className='form-group row'>
                    <div className='col-sm-3 col-md-3 col-lg-3 col-xl-3'>
                        <b>{i18n.translate("current_value")}: </b>
                    </div>
                    <div className='col-sm-9 col-md-9 col-lg-9 col-xl-9'>
                        {this.state.valuesToShow.map((week) => {
                            return (
                                <label style={{ display: 'block' }}>{week}</label>
                            )
                        })}
                    </div>
                </div>
                {this.state.form.update != false &&
                    <DescriptionGIE type={this.state.detail.type} />
                }
                {this.state.form.update == false &&
                    <NewGIE />
                }
                <div className='form-group row'>
                    <div className='col-sm-3 col-md-3 col-lg-3 col-xl-3'>
                        <b>{i18n.translate("new_value")}: </b>
                    </div>
                    <div className='col-sm-9 col-md-9 col-lg-9 col-xl-9 arrayStringNewValues'>
                        <div class='table-responsive'>
                            <table class='inJQueryAlerts table-sm table-borderless reducedSize'>
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th class='weekday'>{i18n.translate("monday")}</th>
                                        <th class='weekday'>{i18n.translate("tuesday")}</th>
                                        <th class='weekday'>{i18n.translate("wednesday")}</th>
                                        <th class='weekday'>{i18n.translate("thursday")}</th>
                                        <th class='weekday'>{i18n.translate("friday")}</th>
                                        <th class='weekday'>{i18n.translate("saturday")}</th>
                                        <th class='weekday'>{i18n.translate("sunday")}</th>
                                        <th class='weekday'>{i18n.translate("default_schedule")}</th>
                                        <th class='button'></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.valuesToUpdate.map((wk, index) => {
                                        return (
                                            <tr class='trWeek'>
                                                <td class='button'>
                                                    <img className='removeContent' onClick={() => this.removeOption(index)} src={RemoveContent} width="20px" height="20px" />
                                                </td>
                                                {wk.map(((w, wkItemIndex) => {
                                                    return (
                                                        <>
                                                            {wkItemIndex == 0 &&
                                                                <>
                                                                    <td class={'weekDay-' + index} name={index}>
                                                                        <input onClick={(event) => this.checkTheDay(index, wkItemIndex, event)} name="monday" type="checkbox" checked={w.monday} value={w.monday} />
                                                                    </td>
                                                                    <td class={'weekDay-' + index} name={index}>
                                                                        <input onClick={(event) => this.checkTheDay(index, wkItemIndex, event)} name="tuesday" type="checkbox" checked={w.tuesday} value={w.tuesday} />
                                                                    </td>
                                                                    <td class={'weekDay-' + index} name={index}>
                                                                        <input onClick={(event) => this.checkTheDay(index, wkItemIndex, event)} name="wednesday" type="checkbox" checked={w.wednesday} value={w.wednesday} />
                                                                    </td>
                                                                    <td class={'weekDay-' + index} name={index}>
                                                                        <input onClick={(event) => this.checkTheDay(index, wkItemIndex, event)} name="thursday" type="checkbox" checked={w.thursday} value={w.thursday} />
                                                                    </td>
                                                                    <td class={'weekDay-' + index} name={index}>
                                                                        <input onClick={(event) => this.checkTheDay(index, wkItemIndex, event)} name="friday" type="checkbox" checked={w.friday} value={w.friday} />
                                                                    </td>
                                                                    <td class={'weekDay-' + index} name={index}>
                                                                        <input onClick={(event) => this.checkTheDay(index, wkItemIndex, event)} name="saturday" type="checkbox" checked={w.saturday} value={w.saturday} />
                                                                    </td>
                                                                    <td class={'weekDay-' + index} name={index}>
                                                                        <input onClick={(event) => this.checkTheDay(index, wkItemIndex, event)} name="sunday" type="checkbox" checked={w.sunday} value={w.sunday} />
                                                                    </td>
                                                                </>
                                                            }
                                                            {wkItemIndex > 0 &&
                                                                <td class={'timeInterval-' + index} style={{ display: 'inline-flex' }} name={index}>
                                                                    <select class='form-select selectStandard newValueHour'>
                                                                        {this.state.optionsHour.map((h) => {
                                                                            return (
                                                                                <>
                                                                                    {w.hour == h.value ? <option value={h.value} selected>{h.value}</option>
                                                                                        : <option value={h.value}>{h.value}</option>
                                                                                    }
                                                                                </>
                                                                            )
                                                                        })}
                                                                    </select>
                                                                    <select class='form-select selectStandard newValueMinute'>
                                                                        {this.state.optionsMinute.map((m) => {
                                                                            return (
                                                                                <>
                                                                                    {w.minute == m.value ? <option value={m.value} selected>{m.value}</option>
                                                                                        : <option value={m.value}>{m.value}</option>
                                                                                    }
                                                                                </>
                                                                            )
                                                                        })}
                                                                    </select>
                                                                </td>
                                                            }
                                                        </>
                                                    )
                                                }))}
                                            </tr>
                                        )
                                    })}
                                    <div>
                                        <img onClick={this.addOption} className='addContent' src={AddContent} width="30px" />
                                    </div>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default IntervalDayAndHourTemplate;
